module.exports = __webpack_public_path__ + "img/Picture13.b8acc4d5.png";